// extracted by mini-css-extract-plugin
export default {"container":"InteractiveVoiceResponse_container__MO5Du"};